/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { AllContentCard, AllContentPage, AllContentPlaylist } from '../../../../shared/models/all-content/all-content.model';
import { Page } from '../../../../shared/models/page';
import { ObservableResult } from '../../../../shared/store';
import { AllContentDataService } from './all-content-data.service';

@Injectable()
export class MockAllContentDataService implements AllContentDataService {
  loadAllPages(page: number, size: number, term: string): ObservableResult<Page<AllContentPage>> {
    return ObservableResult.ofSuccess();
  }

  loadAllPlaylists(page: number, size: number, term: string, type?: string): ObservableResult<Page<AllContentPlaylist>> {
    return ObservableResult.ofSuccess();
  }

  loadAllCards(page: number, size: number, term: string): ObservableResult<Page<AllContentCard>> {
    return ObservableResult.ofSuccess();
  }
}
